export default __webpack_public_path__ + "static/AlexBrush-Regular-b50947ef756f43126a521076ba65c13a.ttf";